import React, { useEffect, useState } from 'react';

import { 
    Spinner, Sidebar, 
    ConfirmationModal, CustomPasswordInput, AlertMessage, SubmenuPopover 
} from "components";

import { func_url, func_validation, isArrayNotEmpty, isFunction, truncateValueAtPosMatch } from 'functions';

import homeIcon from 'assets/images/dashboard.svg';
import ic_invoice from 'assets/images/ic_invoice.svg';
import ic_registration from 'assets/images/invoice.svg';
import default_user from 'assets/images/default_user.png';
import ic_collapse_arrow from "assets/images/ic_collapse_arrow_primary.svg";
import ic_expand_arrow from "assets/images/ic_expand_arrow_primary.svg";
import ic_user_settings from "assets/images/ic_user_settings.svg";
import ic_permission from 'assets/images/ic_permission.svg';
import ic_activity_log from 'assets/images/ic_activity_log.svg';
import settingsIcon from 'assets/images/settings.svg';
import ic_requested_com from 'assets/images/ic_requested_com.svg';

import { distributorPortalBaseUrl } from "dataflow/distributorPortal/constants";

import 'assets/scss/distributorPortal/modules/dashboardSidebar.scss';

import 'assets/scss/distributorPortal/modules/dashboardSidebar.scss';
import { Toaster } from 'components/notification/Toaster';
import { useCustomSelector } from 'hooks';
import useResetPassword from './hooks/useResetPassword';
import { useAuthenticationActions } from 'dataflow/distributorPortal/actions/useAuthentication.actions';
import { useHistory, useLocation } from 'react-router-dom';
import usePromiseInstance_authorization from 'dataflow/distributorPortal/actions/config';
import { useDispatch } from 'react-redux';





export function DashboardSidebarPresentation({ userInfo }) {
    const history = useHistory();
    const location = useLocation();
    const dispatch = useDispatch();

    const { logout } = useAuthenticationActions();
    const { logout_requesting } = useCustomSelector("distributorPortal_authentication");
    const { userPermissions } = useCustomSelector("distributorPortal_userManagementReducers");
    const request = usePromiseInstance_authorization();

    // States
    const {
        setIsModalVisible: setIsModalVisible_resetPwd,
        resetPwdModal
    } = useResetPassword(userInfo);

    let profileImage = func_validation.getObjectPropertyValue(userInfo, "profileImage", default_user);
    let fullName = func_validation.getObjectPropertyValue(userInfo, "FullName", "");
    if (func_validation.isStringEqual_caseInsensitive(fullName, "-")) fullName = "";
    let userEmail = func_validation.getObjectPropertyValue(userInfo, "UserName", "");
    if (func_validation.isStringEqual_caseInsensitive(userEmail, "-")) userEmail = "";

    // default logo 
    // if need to change new default xilnex logo, change at azure storage with same file name: Xilnex_logo.png
    let logo = "https://xilnexbilling.blob.core.windows.net/billing-assets/Xilnex_logo.png"
    let dealerInfo = func_validation.getObjectPropertyValue(userInfo, "Dealer");
    if (func_validation.isArrayNotEmpty(dealerInfo)) {
        if (func_validation.isStringNotEmpty(dealerInfo[0]?.ImageFile)) logo = dealerInfo[0]?.ImageFile
    }

    const [totalCOMRequests, setTotalCOMRequests] = useState(0);
    const { isCOMRequestStatusUpdated } = useCustomSelector("companyInfo");
    function getCOMRequests() {
        request(null, (axios) => {
            if (isFunction(axios)) {
                axios.get('/ComInfo/GetRequest?requestStatus=Pending')
				.then(function (response) {
					// handle success
					let data = response?.data;
					if (isArrayNotEmpty(data)) {
						setTotalCOMRequests(data.length);
					}
					else setTotalCOMRequests(0);
				})
				.catch(function (response) {
					// handle error
					if (response?.data?.exceptionMessage) {
						Toaster({
							type: "error",
							msg: response?.data?.exceptionMessage
						})
					}
				})
				.finally(function () {
					// always executed
				});
            }
		});
    }
    useEffect(() => {
        getCOMRequests();
    }, [isCOMRequestStatusUpdated]);
    useEffect(() => {
        setInterval(() => {
            getCOMRequests();
        }, 300000)
    },[]);

    return (
        <>
            {/* Reset Password */}
            {resetPwdModal}

            <Sidebar sidebarClassName={"distributorPortal-dashboardSidebar"}
                isWidthChangerIconVisible

                isHeaderVisible
                isHeaderImageVisible={func_validation.isObjectNotEmpty(userInfo)}
                headerImageClassName={"distributorPortal-dashboardSidebar-headerImage"}
                widthChangeIconClassName={"distributorPortal-dashboardSidebar-headerImage-widthChangerIcon"}
                headerImage={logo} headerImageAlt={"Company Logo"}
                headerImageUrlRedirection={distributorPortalBaseUrl + "dashboard"}

                isHeaderDetailsVisible
                isHeaderDetailsVisible_topBorder isHeaderDetailsVisible_bottomBorder
                headerDetailsDisplay={(isCollapsed) => {

                    return (
                        <div className={"distributorPortal-dashboardSidebar-headerDetails d-flex align-items-center " +
                                        (isCollapsed? "justify-content-center ":"")}>

                            {/* Profile Image */}
                            {/* <img className={"distributorPortal-dashboardSidebar-headerImage"}
                                src={profileImage}
                                alt={"Profile Image"}
                            /> */}

                            {/* User Details */}
                            {(!isCollapsed)? (
                                <div className={"distributorPortal-dashboardSidebar-userDetailsWrapper"}>
                                    {/* Full Name */}
                                    <div className={"distributorPortal-dashboardSidebar-fullName noWrap-text-ellipsis"}>
                                        {fullName}
                                    </div>

                                    {/* Profile Setting Icon */}
                                    <SubmenuPopover
                                        className={"distributorPortal-dashboardSidebar-profileSettings"}
                                        
                                        triggerClassName={"distributorPortal-dashboardSidebar-profileSettings-trigger"}
                                        trigger={(
                                            <div className={"d-flex justify-content-between"}>
                                                {/* Email */}
                                                <div className={"distributorPortal-dashboardSidebar-userEmail noWrap-text-ellipsis"}>
                                                    {userEmail}
                                                </div>

                                                {/* Trigger */}
                                                <img
                                                    className={"distributorPortal-dashboardSidebar-profileSettings-icon"}
                                                    src={ic_user_settings}
                                                    alt={"Profile Settings Icon"}
                                                />
                                            </div>
                                        )}
                                        triggerPosition={"right"}

                                        menu={[
                                            {
                                                label: "Reset Password",
                                                callbackFunc: () => setIsModalVisible_resetPwd(true)
                                            },
                                            {
                                                label: (
                                                    <>
                                                        <span>Logout</span>
                                                        {logout_requesting && <Spinner size={0} />}
                                                    </>
                                                ) ,
                                                callbackFunc: logout
                                            }
                                        ]}
                                    />
                                </div>
                            ):""}

                        </div>
                    );
                }}

                menuArray={[
                    {
                        itemIconDisplay: (<img src={homeIcon}/>),
                        itemLabel: "Home",
                        path: distributorPortalBaseUrl + "dashboard",
                    },
                    // {
                    //     itemIconDisplay: (<img src={ic_invoice}/>),
                    //     itemLabel: "Invoices",
                    //     // path: distributorPortalBaseUrl + "dashboard/invoices",
                    //     subItemLabel: "Coming Soon",
                    //     isDisabled: true,
                    //     // subMenu: [
                    //     //     {
                    //     //         isIconHidden: true,
                    //     //         isItemSelectedIndicatorHidden: true,
                    //     //         itemLabel: "General",
                    //     //         path: distributorPortalBaseUrl + "dashboard/invoices/general",
                    //     //     },
                    //     //     {
                    //     //         isIconHidden: true,
                    //     //         isItemSelectedIndicatorHidden: true,
                    //     //         itemLabel: "Company",
                    //     //         path: distributorPortalBaseUrl + "dashboard/invoices/company",
                    //     //     },
                    //     // ]
                    // },
                    {
                        itemIconDisplay: (<img src={ic_registration}/>),
                        itemLabel: "Client Registration",
                        // subItemLabel: "Coming Soon",
                        // isDisabled: true,
                        path: distributorPortalBaseUrl + "dashboard/registration/client",
                    },
                    // {
                    //     itemIconDisplay: (<img src={settingsIcon}/>),
                    //     itemLabel: "User Management",
                    //     isDisabled: !(userPermissions?.Dealer_User_View),
                    //     path: distributorPortalBaseUrl + "dashboard/userManagement/user",
                    //     subMenu: [
                    //         {
                    //             isIconHidden: true,
                    //             isItemSelectedIndicatorHidden: true,
                    //             itemLabel: "User List",
                    //             isDisabled: !(userPermissions?.Dealer_User_View),
                    //             path: distributorPortalBaseUrl + "dashboard/userManagement/user",
                    //         },
                    //         {
                    //             isIconHidden: true,
                    //             isItemSelectedIndicatorHidden: true,
                    //             itemLabel: "User Group",
                    //             isDisabled: !(userPermissions?.Dealer_UserGroup_View),
                    //             path: distributorPortalBaseUrl + "dashboard/userManagement/userGroup",
                    //         },
                    //     ]
                    // },
                    // {
                    //     itemIconDisplay: (<img src={ic_permission}/>),
                    //     itemLabel: "Permission",
                    //     isDisabled: !(userPermissions?.Dealer_Permission_View),
                    //     path: distributorPortalBaseUrl + "dashboard/userManagement/permission",
                    // },
                    // {
                    //     itemIconDisplay: (<img src={ic_registration}/>),
                    //     itemLabel: "User Logging",
                    //     // subItemLabel: "Coming Soon",
                    //     // isDisabled: true,
                    //     path: distributorPortalBaseUrl + "dashboard/user-logging",
                    // },
                    {
                        itemIconDisplay: (<img src={ic_activity_log}/>),
                        itemLabel: "Activity Log",
                        isDisabled: !(userPermissions?.Dealer_General_ViewActivityLog),
                        path: distributorPortalBaseUrl + "dashboard/activityLog",
                    },
                    {
                        itemIconDisplay: (<img src={ic_requested_com}/>),
                        itemLabel: "COM Activation",
                        isDisabled: !(userPermissions?.Dealer_ComInfo_View),
                        path: distributorPortalBaseUrl + "dashboard/comActivation",
                    },
                ]}

                isSubMenuIconHidden

                history={history}
                currentPath={location?.pathname}
            />
        </>
        
    );
}